$(document).ready(function() {

    ub.data.mock = {

        tempPiping731: {

            numberOfColors: 1, 
            size: "1/8",
            layers: [

                        {

                            colorCode: "B",
                            layer: 1,
                            status: false,

                        },
                        {

                            colorCode: "",
                            layer: 1,
                            status: false,

                        },
                        {

                            colorCode: "",
                            layer: 1,
                            status: false,

                        }

                    ]    

        }

    }

});
